import "../styles/Hero.css";
import streamerpw from "../assets/streamerpw.jpg";
import BotonContacto from "./BotonContacto";
export default function Hero  ()  {
  return (
    <section className="hero">
      {/* Imagen de fondo */}
      <img
        src={streamerpw}
        alt="Streamer trabajando desde casa"
        className="hero-image"
      />

      {/* Texto encima de la imagen */}
      <div className="hero-content">
        <h1 className="hero-title">
          Trabaja desde casa y gana en dólares
        </h1>
        <p className="hero-subtitle">
          Únete a Pretty Woman y recibe pagos semanales en apps seguras, 
          con el apoyo de tutores y una gran comunidad.
        </p>
        <BotonContacto>
          {(link) =>
            link ? (
              <a
                href={link.url}
                target="_blank"
                rel="noreferrer"
                className="hero-button"
              >
                ¡Únete ahora!
              </a>
            ) : (
              <span className="hero-button">¡Únete ahora!</span>
            )
          }
        </BotonContacto>
      </div>
    </section>
  );
}
